/* eslint-disable */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DropDown from '../../common/DropDown';

import history from '../../../history';

export default class EtaDropDown extends Component {
    constructor(props) {
        super(props);
        this.renderOption = this.renderOption.bind(this);
    }

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        return (
            <DropDown
                filterKey="eta_within"
                selected={currentUrlParams.get('eta')}
                defaultSelectionFromParam={true}
                options={this.options}
                defaultSelection={this.getDefaultSelection()}
                renderSelected={this.renderSelected}
                onFilterChange={this.onFilterChange}
                renderOption={this.renderOption}
            />
        );
    }

    onFilterChange = (id, value) => {
        const currentUrlParams = new URLSearchParams(history.location.search);
        if (value.label == 'All ETAs') {
            currentUrlParams.delete('eta_within_min');
            currentUrlParams.delete('eta_within_max');
        } else if (value.label == 'Early') {
            currentUrlParams.set('eta_within_min', '15');
            currentUrlParams.delete('eta_within_max');
        } else if (value.label == 'Warning') {
            currentUrlParams.set('eta_within_min', '0');
            currentUrlParams.set('eta_within_max', '15');
        } else {
            currentUrlParams.delete('eta_within_min');
            currentUrlParams.set('eta_within_max', '0');
        }
        currentUrlParams.set('eta', value.value);
        history.push(`?${currentUrlParams.toString()}`);
    };

    renderSelected = (value, isOpen) => (
        <div className="dropdown-placeholder">
            {this.renderImage(value.label)}
            {value.label}
        </div>
    );

    renderImage = label => {
        if (label == 'Early') {
            return <img src="/static/images/green-circle.png" />;
        }
        if (label == 'Warning') {
            return <img src="/static/images/orange-circle.png" />;
        }
        if (label == 'Late') {
            return <img src="/static/images/red-circle.png" />;
        }
        return null;
    };

    renderOption = option => (
        <div>
            {this.renderImage(option.label)}
            {option.label}
        </div>
    );

    getDefaultSelection() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        if (currentUrlParams.get('eta')) {
            const selected = this.options.filter(
                option => option.value == currentUrlParams.get('eta'),
            )[0];
            if (selected) {
                return selected;
            }
            return this.defaultSelection;
        }
        return this.defaultSelection;
    }

    defaultSelection = {
        label: 'All ETAs',
        value: '',
    };

    options = [
        {
            label: 'All ETAs',
            value: '',
        },
        {
            label: 'Early',
            value: 'early',
        },
        {
            label: 'Warning',
            value: 'warning',
        },
        {
            label: 'Late',
            value: 'late',
        },
    ];
}
